import React from 'react';
import styled from 'styled-components';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { ArrowIcon, arrowDirections } from '../../../../common/utilities/arrowIcon';

export const CardTitleLoadingUI = () => {
    return (
        <Container>
            <DateWrap>
                <AnimatedLoadingPlaceholder height='100%' />
            </DateWrap>
            <ArrowWrapper>
                <ArrowIcon arrowDirection={arrowDirections.right} />
            </ArrowWrapper>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 8px 15px;
    font-size: 0;
    line-height: 1.25;
    text-align: left;
    color: #666;
    background-color: white;
    border-bottom: 1px solid #eee;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
`;

const DateWrap = styled.div`
    display: flex;
    flex-direction: row;
    width: calc(100% - 6px);
    height: 21px;
`;

const ArrowWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 10px;
    height: 100%;
    align-items: center;
    justify-content: center;
`;